export { default } from './SpaTreatmentPage';
